import { useEffect, useState } from "react";
import { QueryObject } from "../ListBuildertypes";
import { useListBuilder } from "../../../../context/ListBuilderContext/ListBuilderContext";
import FiltersPreview from "./FiltersPrewiev";
import { removeSubQueryAtPath } from "../ListBuilderScripts";

interface ListColumn {
   techName: string;
   label: string;
}

interface FormFieldOption {
   name: string;
   label: string;
}

interface ListFilterMapperProps {
   listColumns: ListColumn[];
   formFields: FormFieldOption[];
   initialQuery?: QueryObject;
}

const ListFilterMapper: React.FC<ListFilterMapperProps> = ({
   listColumns,
   formFields,
   initialQuery,
}) => {
   const [selectedTechName, setSelectedTechName] = useState<string>("");
   const [selectedLabel, setSelectedLabel] = useState<string>("");
   const [selectedFormField, setSelectedFormField] = useState<string>("");

   const { queryObject, setQueryObject } = useListBuilder();

   useEffect(() => {
      if (listColumns.length === 0) return;

      setSelectedTechName("");
      setSelectedLabel("");
      setSelectedFormField("");
      setQueryObject(
         initialQuery ?? {
            type: "",
            properties: {},
            subQueries: [],
            size: 10,
         },
      );
   }, [listColumns]);

   const handleAddFilter = () => {
      if (!selectedTechName || !selectedFormField) return;

      setQueryObject((prev) => ({
         ...prev,
         properties: {
            ...prev.properties,
            [selectedTechName]: { techName: selectedFormField, label: selectedLabel },
         },
      }));

      setSelectedTechName("");
      setSelectedLabel("");
      setSelectedFormField("");
   };

   const handleRemoveProperty = (fieldName: string) => {
      setQueryObject((prev) => {
         const newProps = { ...prev.properties };
         delete newProps[fieldName];
         return { ...prev, properties: newProps };
      });
   };

   const handleRemoveSubQuery = (path: string[]) => {
      setQueryObject((prev) => ({
         ...prev,
         subQueries: removeSubQueryAtPath(structuredClone(prev.subQueries), path),
      }));
   };

   const selectStyle: React.CSSProperties = {
      border: "1px solid lightgray",
      borderRadius: "5px",
      padding: "4px",
      width: "100%",
   };
   return (
      <div>
         <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <span>Kolumna listy:</span>
            <select
               value={selectedTechName}
               onChange={(event) => {
                  setSelectedTechName(event.target.value);
                  setSelectedLabel(
                     listColumns.find((col) => col.techName === event.target.value)?.label ?? "",
                  );
               }}
               style={selectStyle}
            >
               <option value="">-- wybierz kolumnę --</option>
               {listColumns.map((column) => (
                  <option key={column.techName} value={column.techName}>
                     {column.label}
                  </option>
               ))}
            </select>

            <span>Pole formularza:</span>
            <select
               value={selectedFormField}
               onChange={(event) => setSelectedFormField(event.target.value)}
               style={selectStyle}
            >
               <option value="">-- wybierz pole --</option>
               {formFields.map((field) => (
                  <option key={field.name} value={field.name}>
                     {field.label}
                  </option>
               ))}
            </select>

            <button
               style={{
                  border: "1px solid lightgray",
                  borderRadius: "5px",
                  backgroundColor: "#bbdd40",
                  padding: "4px 12px",
                  cursor: selectedTechName && selectedFormField ? "pointer" : "not-allowed",
                  opacity: selectedTechName && selectedFormField ? 1 : 0.5,
               }}
               onClick={handleAddFilter}
               disabled={!selectedTechName || !selectedFormField}
            >
               Dodaj filtr
            </button>
         </div>

         <div style={{ display: "flex", flexDirection: "column", marginTop: "12px" }}>
            <span style={{ marginBottom: "5px" }}>Dodane filtry:</span>
            <FiltersPreview
               queryObject={queryObject}
               onRemoveProperty={handleRemoveProperty}
               onRemoveSubQuery={handleRemoveSubQuery}
            />
         </div>
      </div>
   );
};

export default ListFilterMapper;
